import { Component, HostListener, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { CoordinatePointModel } from 'src/app/models/coordinate-point';

@Component({
  selector: 'app-coord-point-duplication-warning',
  templateUrl: './coord-point-duplication-warning.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class CoordPointDuplicationWarningComponent implements OnInit {
  @Input() duplicateCoordinatePoints: CoordinatePointModel[];
  @Input() onUserResponse : Subject<string>;
  static PROCEED = "Proceed";
  static CANCEL = "Cancel";
  constructor(private bsModalRef : BsModalRef) { }

  ngOnInit(): void {
    this.onUserResponse = new Subject();
  }
  proceed(){
    this.onUserResponse.next(CoordPointDuplicationWarningComponent.PROCEED);
    this.bsModalRef.hide();
  }

  @HostListener('document:keydown.escape', ['$event']) 
  onEscape(event: KeyboardEvent) {
    this.cancel(false); // escape key already hides the modal
  }


  cancel(hideModal: boolean = true){
    this.onUserResponse.next(CoordPointDuplicationWarningComponent.CANCEL);
    hideModal? this.bsModalRef.hide(): false;
  }

}
